import constants from 'common/helpers/constants'


interface ISubscriptionStatuses {
  isUndeliverable: boolean
  isPaused: boolean
  isActive: boolean
  isOnHold: boolean
  isUnpaid: boolean
  isPending: boolean
  isPendingUpgrade: boolean
  isPendingChangePlan: boolean
  isCancelled: boolean
  isNotSubscribed: boolean
  isWaitingProlong: boolean
}

const getSubscriptionStatuses = ({ status, addressStatus }): ISubscriptionStatuses => {
  const isUndeliverable: boolean = (
    status === constants.subscriptionStatuses.undeliverable
    || addressStatus === constants.subscriptionStatuses.undeliverable.toUpperCase()
  )

  return {
    isUndeliverable,
    isPaused: status === constants.subscriptionStatuses.paused,
    isActive: status === constants.subscriptionStatuses.active,
    isOnHold: status === constants.subscriptionStatuses.onHold,
    isUnpaid: status === constants.subscriptionStatuses.unpaid,
    isPending: status === constants.subscriptionStatuses.pending,
    isPendingUpgrade: status === constants.subscriptionStatuses.pendingUpgrade,
    isPendingChangePlan: status === constants.subscriptionStatuses.pendingChangePlan,
    isCancelled: status === constants.subscriptionStatuses.cancelled,
    isNotSubscribed: status === constants.subscriptionStatuses.notSubscribed,
    isWaitingProlong: status === constants.subscriptionStatuses.waitingProlong,
  }
}


export default getSubscriptionStatuses
